import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

const fetchSmartContract = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response.data;
};

export const useSdo = (props: any): UseQueryResult<any> => {
    const { getToken } = useAuth();
    const { chain, sdoId, onSuccess, onError } = props;

    const url = `/graphchain/${chain}/${sdoId}`;
    return useQuery(
        ['dictionary', sdoId],
        async () => fetchSmartContract(url, getToken()),
        { ...fetchSmartContract, onSuccess, onError }
    );
};
